import FJVideoSettingsContainer from '../FJVideoSettings/FJVideoSettingsContainer';
import PropTypes from 'prop-types';
import FJConstant from '../../../constants/FJConstant';
import FJProductToVideoStartContainer from '../FJProductToVideoStart/FJProductToVideoStartContainer';
import FJProductToVideoScriptEditContainer from '../FJProductToVideoScriptEdit/FJProductToVideoScriptEditContainer';
import FJDisplayPanel from '../FJDisplayPanel/FJDisplayPanel';
const FJProductToVideo = props => {
    const { textToVideoStep } = props;
    return (
        <>
            <FJDisplayPanel active={textToVideoStep === FJConstant.STEP_TYPE_HOME}>
                <FJProductToVideoStartContainer />
            </FJDisplayPanel>
            <FJDisplayPanel active={textToVideoStep === FJConstant.STEP_TYPE_SCRIPTS_EDIT}>
                <FJProductToVideoScriptEditContainer />
            </FJDisplayPanel>
            <FJDisplayPanel active={textToVideoStep === FJConstant.STEP_TYPE_VIDEO_SETTINGS}>
                <FJVideoSettingsContainer />
            </FJDisplayPanel>
        </>
    );
};

FJProductToVideo.propTypes = {
    textToVideoStep: PropTypes.string,
};

export default FJProductToVideo;
